var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/component/x-file-item-upload.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-button";
import "@adornis/chemistry/elements/components/x-progress-bar.js";
import "@adornis/file-utils/db/files.js";
import "@adornis/popover/x-dropdown-selection";
import "@adornis/popover/x-dropdown-selection.js";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { createRef, ref } from "lit/directives/ref.js";
import { firstValueFrom, timer } from "rxjs";
import "./x-file-item";
var XFileItemUpload = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this._uploadClassSelectionRef = createRef();
    this._uploaded = false;
    this._isUploading = false;
  }
  willUpdate(_changedProperties) {
    super.willUpdate(_changedProperties);
    if (!this.file)
      return;
    this._possibleUploadClasses = this._getPossibleFileClasses(this.file);
    if (this._possibleUploadClasses.length === 1) {
      this._uploadClass = this._possibleUploadClasses[0];
    }
    if (this.file && this._uploadClass && !this._isUploading && !this._uploaded) {
      this._isUploading = true;
      this._uploadClass.upload(this.file, { additionalInfo: { meta: JSON.stringify({ fileName: "test-filename :D" }) } }).then(async (file) => {
        const resolvedFile = await this._uploadClass?.getByID(file)(
          this._uploadClass.allFields
        );
        const name = this.file?.name.substring(0, this.file?.name.lastIndexOf("."));
        if (resolvedFile && resolvedFile.meta && name) {
          resolvedFile.meta.fileName = name;
          await resolvedFile.save();
        }
        this._isUploading = false;
        this._uploaded = true;
        firstValueFrom(timer(1500)).then(() => this.dispatchEvent(new Event("remove")));
      });
    }
  }
  render() {
    if (!this.file)
      return nothing;
    return html`
      <x-file-item .file=${this.file}>
        ${(this._possibleUploadClasses?.length ?? 0) > 1 && !this._uploadClass ? html`
              <x-flex ${css({ gap: "8px" })} horizontal crossaxis-center>
                <x-dropdown-selection
                  flex
                  .selectables=${this._possibleUploadClasses}
                  .renderString=${(item) => {
      if (!item)
        return "";
      return item._class;
    }}
                  placeholder="Typ"
                  ${ref(this._uploadClassSelectionRef)}
                  @value-picked=${() => this.requestUpdate()}
                ></x-dropdown-selection>
                ${this._uploadClassSelectionRef.value?.value ? html`
                      <x-icon
                        ${css({
      fontSize: "24px",
      background: this.colors.accent,
      padding: "4px",
      borderRadius: "4px",
      cursor: "pointer"
    })}
                        @click=${() => {
      const fileClass = this._uploadClassSelectionRef.value?.value.value;
      if (!fileClass)
        return;
      this._uploadClass = fileClass;
    }}
                      >
                        upload
                      </x-icon>
                    ` : nothing}
              </x-flex>
            ` : nothing}
        ${this._isUploading ? html` <x-text> Datei wird hochgeladen... </x-text> ` : nothing}
        ${this._uploaded ? html` <x-text ${css({ fontSize: "16px", color: this.colors.accent })}> Hochgeladen </x-text> ` : nothing}
      </x-file-item>
    `;
  }
  _getPossibleFileClasses(file) {
    const possibleClasses = (this.fileClassSpecs ?? []).filter((fileClassSpec) => {
      return fileClassSpec.isValid(file);
    }).map((classSpec) => classSpec.fileClass);
    return possibleClasses;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {}
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false })
], XFileItemUpload.prototype, "file", 2);
__decorateClass([
  property({ attribute: false })
], XFileItemUpload.prototype, "fileClassSpecs", 2);
__decorateClass([
  state()
], XFileItemUpload.prototype, "_possibleUploadClasses", 2);
__decorateClass([
  state()
], XFileItemUpload.prototype, "_uploadClass", 2);
__decorateClass([
  state()
], XFileItemUpload.prototype, "_uploadClassSelectionRef", 2);
__decorateClass([
  state()
], XFileItemUpload.prototype, "_uploaded", 2);
XFileItemUpload = __decorateClass([
  customElement("x-file-item-upload")
], XFileItemUpload);
export {
  XFileItemUpload
};
